<template>
  <highcharts :options="chartOptions" :ref="barchart_id"></highcharts>
</template>

<script>
import { Chart } from "highcharts-vue";
import moment from "moment";
import Highcharts from "highcharts/highcharts.js";
import gp from "@/plugins/generalPlugins.js";

export default {
  name: "bar_chart_highchart",
  props: {
    dataset: Array,
    source: Array,
    height: {
      type: String,
      default: function () {
        return null;
      },
    },
    yLabel: {
      type: String,
      default: function () {
        return "Mentions";
      },
    },
    barchart_id: {
      type: String,
      default: function () {
        return "barchart-element";
      },
    },
    is_clickable: {
      type: Boolean,
      default: function () {
        return true;
      },
    },
  },
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      data: this.dataset,
      chartOptions: {},
    };
  },
  methods: {
    loadChart: function () {
      let self = this;
      this.chartOptions = {
        chart: {
          type: "column",
          backgroundColor: "transparent",
          height: self.height ? self.height : "",
        },
        credits: {
          enabled: false,
        },
        colors: [
          '#28A745',
          '#ffc007',
          '#f17f28',
          '#dc3444',
        ],
        title: {
          text: "",
        },
        subtitle: {
          text: "",
        },
        xAxis: {
          type: "category",
          labels: {
            rotation: -45,
            style: {
              fontSize: "13px",
              fontFamily: "Verdana, sans-serif",
            },
            format: "{value:,.0f}"
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: self.yLabel,
          },
          labels: {
            formatter: function () {
              return gp.kmbFormatter(this.value); 
            }
          }
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          column: {
            colorByPoint: true
          },
          series: {
            cursor: "pointer",
            events: {
              click: function (event) {
                if (self.is_clickable == true) {
                  let params = {}
                  let q = event.point.name;
                  params = self.$route.query;
                  params.q = q;
                  self.$router.push({ path: "/posts", query: params });
                }
              },
            },
          },
        },
        tooltip: {
          // pointFormat: "Jumlah Mention: <b>{point.y}</b>",
          formatter: function () {
            var s =
              '<small>' + this.key + '</small><br>'
              + '<span>' + this.series.name + '</span> : '
              + Highcharts.numberFormat(this.point.y, 0, ',', ',')
            // + ' (' + Math.round(this.point.percentage) + '%)';
            return s;
          }
        },
        series: [
          {
            name: "Mentions",
            data: this.data,
            dataLabels: {
              enabled: true,
              rotation: -90,
              color: "#FFFFFF",
              align: "right",
              format: "{point.y}",
              y: 10,
              style: {
                fontSize: "13px",
                fontFamily: "Verdana, sans-serif",
              },
            },
            label: {
              connectorAllowed: false,
            },
            point: {
              events: {
                click: function () {
                  let source = self.source
                  let start = "";
                  let end = "";
                  let params = {};

                  if (source != null) {
                    start = moment(self.$route.query.from).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    end = moment(self.$route.query.to).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );

                    params = {
                      from: start,
                      to: end,
                    };

                    if ("topic_selected" in self.$route.query) {
                      params.topic_selected = self.$route.query.topic_selected;
                    }
                    if ("cakupan" in self.$route.query) {
                      params.cakupan = self.$route.query.cakupan;
                    }

                    if (source) {
                      params.sources = btoa(source);
                    }

                    self.$router.push({ path: "/posts", query: params });
                  }
                },
              },
            },
          },
        ],
      };
    },
  },
  mounted: function () {
    if (this.data != null) {
      this.loadChart();
    }
  },
};
</script>
